import React, { useState, ChangeEvent, useEffect } from "react"
import ModalWrap from './index';
import styles from "./Modal.module.css"
import http from './../../Service/http';
import { student } from './../../store/student';
import BlueBtn from "../SidBarButtons/BlueBtn";
import { getDescription } from "../../Service/properties";
import { property } from "../../store/poperty";
import { updDescription } from './../../Service/properties';
import { AiFillBell } from "react-icons/ai"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSave } from "react-icons/fa"
import { auth } from "../../store/auth";

type NotesModalPropType = {
    close: () => void
    modal: boolean
    id?: number
}

function NotesModal( { close, modal, id }: NotesModalPropType ) {

    const notify = (title:string) => toast(title);
    const [ description, setDescription ] = useState<string>("")

    const saveDesc = async () => {
        if(id == 0){
            const res = await http.post("/description-insert", {
                id_student: student.student.id_student, 
                id_user: auth.user.data.id, 
                okno_description: description
            })
            if( res.data.data.result ){
                const oknoDesc = await getDescription(student.student.id_student)
                property.newDescription(oknoDesc)
                notify("Успешно добавлено!")
            }
            return
        }else{
            if(id){
                const res = await updDescription( id, student.student.id_student, description)
                if( res ){
                    const oknoDesc = await getDescription(student.student.id_student)
                    property.newDescription(oknoDesc)
                    notify("Успешно обновлен!")
                }
            }
        }
    }

    const currentDesc = async(id: number) => {
        const desc = await property.description.find(item => item.id_okno_description = id)
        
        if( desc ){
            setDescription(desc.okno_description)
        }
    }

    useEffect(() => {
        if(id)currentDesc(id)
    }, [id])
    return ( 
        <>
            <ModalWrap setIsOpen={() => {
                setDescription('')
                close()
                }} title={"Примечание"}  isOpen={modal} id={23} >
                <textarea value={ description } onChange={(e:ChangeEvent<HTMLTextAreaElement>) => {
                    setDescription(e.target.value)
                }} className={styles.textArea} rows={12}>
                </textarea>
                <div className="container">
                    <div className="demo-flex-spacer">
                    </div>
                    
                </div>
                <div className={styles.btnWrap} > 
                    {
                        description? <BlueBtn title="Сохранить" onclick={saveDesc}>
                            <FaSave />
                        </BlueBtn>:
                        <button className={styles.btn}  onClick={() => {
                        }}> <AiFillBell className={styles.btnIcon}/> Отмена </button>    
                    } 
                </div>
            </ModalWrap>
        </>
     );
}

export default NotesModal;